var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PlatformControllerFlowAPI } from '../flow-api/PlatformController';
import { getPublicPath } from '../utils';
import { wrapSimpleUserController } from '../helpers/wrapUserController';
import { createPanoramaClientForViewer } from '../panorama';
import { getPlatformApi } from '../platformApi';
export var blocksControllerWrapper = function (optionalDeps, controllerDescriptor, controllerConfig, viewerScriptFlowAPI, viewerScriptFlowAPIInitPromise, getAppData) { return __awaiter(void 0, void 0, void 0, function () {
    var appData, blocksControllerService, panoramaClient, _a, locationAPI, windowAPI, siteAPI, seoAPI, flowAPI;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                appData = getAppData();
                blocksControllerService = optionalDeps.blocksControllerService;
                if (!controllerDescriptor.method) {
                    return [2 /*return*/];
                }
                panoramaClient = createPanoramaClientForViewer(controllerConfig.essentials, {
                    componentId: controllerDescriptor.id,
                    sentryConfig: controllerDescriptor.sentryConfig,
                    sentryEnvironment: 'Viewer:Worker',
                });
                return [4 /*yield*/, getPlatformApi(controllerConfig.platformAPIs.platformApiProvider)];
            case 1:
                _a = _b.sent(), locationAPI = _a.locationAPI, windowAPI = _a.windowAPI, siteAPI = _a.siteAPI, seoAPI = _a.seoAPI;
                flowAPI = new PlatformControllerFlowAPI({
                    translations: viewerScriptFlowAPI.createTranslations(controllerDescriptor, optionalDeps, { basePath: getPublicPath() }),
                    componentId: controllerDescriptor.id,
                    componentName: controllerDescriptor.componentName,
                    viewerScriptFlowAPI: viewerScriptFlowAPI,
                    appDefinitionId: controllerDescriptor.appDefinitionId,
                    widgetId: controllerDescriptor.id,
                    translationsConfig: controllerDescriptor.translationsConfig,
                    biLogger: controllerDescriptor.biLogger,
                    fedopsConfig: controllerDescriptor.fedopsConfig,
                    sentryConfig: controllerDescriptor.sentryConfig,
                    controllerConfig: controllerConfig,
                    panoramaClient: panoramaClient,
                    locationAPI: locationAPI,
                    windowAPI: windowAPI,
                    siteAPI: siteAPI,
                    seoAPI: seoAPI,
                });
                return [2 /*return*/, Promise.all([viewerScriptFlowAPIInitPromise, flowAPI.init()]).then(function () { return __awaiter(void 0, void 0, void 0, function () {
                        var controller;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, blocksControllerService.getWrappedController(controllerDescriptor, controllerConfig, flowAPI, optionalDeps, appData)];
                                case 1:
                                    controller = (_a.sent());
                                    return [2 /*return*/, wrapSimpleUserController({
                                            controller: controller,
                                            flowAPI: flowAPI,
                                            panoramaClient: panoramaClient,
                                        })];
                            }
                        });
                    }); })];
        }
    });
}); };
//# sourceMappingURL=blocksControllerWrapper.js.map